import { Navigate, Outlet } from 'react-router-dom';
import { useProfile, useUser } from '../../stores';
import LoadingWindow from '../common/ui/LoadingWindow';

interface AdminRouteProps {
  children?: React.ReactNode;
}

// This component is used to protect routes that require admin privileges
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading: authLoading } = useUser();
  const { loading: profileLoading } = useProfile();
  
  if (authLoading || profileLoading) {
    return <LoadingWindow fullScreen={true} overlay={true} message="Loading Moddy AI..." />
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  if (!user.roles.includes('admin')) {
    console.debug('User is not an admin');
    return <Navigate to="/" />;
  }

  return children ? <>{children}</> : <Outlet />;
}; 